import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import Public from '@/components/Public';
import formalUserManage from '@/components/formalUserManage';
import forget from '@/components/forget';
import formalProjectSitesManage from '@/components/formalProjectSitesManage';
import basicConfiguration from '@/components/basicConfiguration';
import archivesMouthsManage from '@/components/archivesMouthsManage';
import loginEditPass from '@/components/loginEditPass';
import incomeType from '@/components/incomeType';
import FoodType from '@/components/FoodType';
import orderManager from '@/components/orderManager';
import departmentManage from '@/components/departmentManage';
import costReport from '@/components/costReport';
import costReportDetail from '@/components/costReportDetail';
import costCategoryDetail from '@/components/costCategoryDetail';
import costCategory from '@/components/costCategory';
import putoutStorage from '@/components/putoutStorage';
import storageDetail from '@/components/storageDetail';
import storageDocument from '@/components/storageDocument';
import invenDocument from '@/components/invenDocument';
import checkPrice from '@/components/checkPrice';
import index from '@/components/index';
import updateOrder from '@/components/updateOrder';
import peopleActor from '@/components/peopleActor';
import DKType from '@/components/DKType';
import rechargeManage from '@/components/rechargeManage';
import accountClose from '@/components/accountClose';
import configProjectDetail from '@/components/configProjectDetail';
import settlementModeManagement from '../components/settlementModeManagement.vue';

Vue.use(Router);

export default new Router({

  routes: [
    {
      path: '/index',
      name: 'index',
      component: index,
    },
    {
      path: '/',
      name: 'Login',
      component: Login,
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/forget',
      name: 'forget',
      component: forget,
    },
    {
      path: '/loginEditPass',
      name: 'loginEditPass',
      component: loginEditPass,
    },
    {
      path: '/Public',
      name: 'Public',
      component: Public,
      children: [
        {
          path: '/DKType',
          name: 'DKType',
          component: DKType,
        },
        {
          path: '/formalUserManage',
          name: 'formalUserManage',
          component: formalUserManage,
        },
        {
          path: '/formalProjectSitesManage',
          name: 'formalProjectSitesManage',
          component: formalProjectSitesManage,
        },
        {
          path: '/basicConfiguration/:siteId',
          name: 'basicConfiguration',
          component: basicConfiguration,
        },
        {
          path: '/archivesMouthsManage/:siteId',
          name: 'archivesMouthsManage',
          component: archivesMouthsManage,
        },
        {
          path: '/incomeType',
          name: 'incomeType',
          component: incomeType,
        },
        {
          path: '/FoodType',
          name: 'FoodType',
          component: FoodType,
        },
        {
          path: '/orderManager',
          name: 'orderManager',
          component: orderManager,
        },
        {
          path: '/departmentManage',
          name: 'departmentManage',
          component: departmentManage,
        },
        {
          path: '/costReport',
          name: 'costReport',
          component: costReport,
        },
        {
          path: '/costCategory',
          name: 'costCategory',
          component: costCategory,
        },
        {
          path: '/costReportDetail/:firstId',
          name: 'costReportDetail',
          component: costReportDetail,
        },
        {
          path: '/costCategoryDetail/:firstId',
          name: 'costCategoryDetail',
          component: costCategoryDetail,
        },
        {
          path: '/putoutStorage',
          name: 'putoutStorage',
          component: putoutStorage,
        },
        {
          path: '/storageDetail/:id',
          name: 'storageDetail',
          component: storageDetail,
        },
        {
          path: '/storageDocument',
          name: 'storageDocument',
          component: storageDocument,
        },
        {
          path: '/invenDocument',
          name: 'invenDocument',
          component: invenDocument,
        },
        {
          path: '/checkPrice',
          name: 'checkPrice',
          component: checkPrice,
        },
        {
          path: '/updateOrder',
          name: 'updateOrder',
          component: updateOrder,
        },
        {
          path: '/peopleActor',
          name: 'peopleActor',
          component: peopleActor,
        },
        {
          path: '/rechargeManage',
          name: 'rechargeManage',
          component: rechargeManage,
        },
        {
          path: '/accountClose',
          name: 'accountClose',
          component: accountClose,
        },
        {
          path: '/configProjectDetail/:ID/:NAME',
          name: 'configProjectDetail',
          component: configProjectDetail,
        },
        {
          path: '/settlementModeManagement',
          name: 'settlementModeManagement',
          component: settlementModeManagement,
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js